import { render, staticRenderFns } from "./SaveContactDialog.vue?vue&type=template&id=0a2bb2ea&scoped=true"
import script from "./SaveContactDialog.vue?vue&type=script&lang=js"
export * from "./SaveContactDialog.vue?vue&type=script&lang=js"
import style0 from "./SaveContactDialog.vue?vue&type=style&index=0&id=0a2bb2ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2bb2ea",
  null
  
)

export default component.exports